var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
import { TransportError } from './framework/Transport';
var Model;
(function (Model) {
    Model["D7000"] = "-MCCebAXbiE8j_aaFYAL";
    Model["D7098Z"] = "-NBRtSdPBGgKwVKkWF6A";
    Model["D8000"] = "-MCCef_9ViDh6_tzz1-B";
    Model["D9000"] = "-MCCejKNIWnfUKoL2p4O";
    Model["DK8500Z"] = "-MCCemk1qR4es7K35oZf";
    Model["DK10000Z"] = "-MCCepP8R020TKfY77yD";
})(Model || (Model = {}));
export class VivitekProjector7000 {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: `op status ?`,
                next: /op\s+status\s+=\s+(\d|NA)|P\d+$|\*Illegal\s+format#/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        this.powerValues = {};
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.displayBlank = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`op blank ?`, /op\s+blank\s+=\s+(\d|NA)|P(\d+)$/i, tags);
                if (match[1] === undefined || match[1] === 'NA')
                    return this.state.displayBlank.value;
                return match[1] === '1';
            }),
            set: (blank, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`op blank = ${blank ? '1' : '0'}`, /op\s+blank\s+=\s+(\d|NA)|P(\d*)$/i, tags);
                if (match[1] === undefined || match[1] === 'NA')
                    return this.state.displayBlank.value;
                return match[1] === '1';
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.displayFreeze = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`op freeze ?`, /op\s+freeze\s+=\s+(\d|NA)|P(\d+)$/i, tags);
                if (match[1] === undefined || match[1] === 'NA')
                    return this.state.displayFreeze.value;
                return match[1] === '1';
            }),
            set: (freeze, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`op freeze = ${freeze ? '1' : '0'}`, /op\s+freeze\s+=\s+(\d|NA)|P(\d*)$/i, tags);
                if (match[1] === undefined || match[1] === 'NA')
                    return this.state.displayFreeze.value;
                return match[1] === '1';
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.firmwareVersion.value;
            }),
            hasControl: () => __awaiter(this, void 0, void 0, function* () {
                try {
                    const match = yield this.socket.send(`op sw.ver ?`, /op\s+sw\.ver\s+=\s+(.+)|P(\d+)$/i, ['get.firmwareVersion']);
                    if (match[1] !== undefined) {
                        this.state.firmwareVersion.update(match[1]);
                        return true;
                    }
                    return false;
                }
                catch (error) {
                    if (error instanceof TransportError && error.code === 'sendTimeout')
                        return false;
                    throw error;
                }
            }),
            powerOffRestrictions: ['get', 'hasControl'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`op status ?`, /op\s+status\s+=\s+(\d|NA)|P(\d*)$|\*Illegal format#$/i, tags);
                // Some Vivitek projectors will respond with op status = \d and others will respond with
                // P\d, so we support both styles of responses.
                let retValue = this.state.power.value;
                if (match[1] && match[1] in this.powerValues) {
                    retValue = this.powerValues[match[1]];
                }
                else if (match[2] && match[2] in this.powerValues) {
                    retValue = this.powerValues[match[2]];
                }
                return retValue;
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const suspendMs = power ? 20000 : 60000;
                this.framework.suspendPolling(suspendMs);
                this.state.busy.update(true);
                let retValue = power;
                // Sometimes we don't get a response for power on or off, so wrap in a try/catch.
                try {
                    const match = yield this.socket.send(`op power.${power ? 'on' : 'off'}`, /op\s+power\.?\s*(on|off)|P(\d*)$/i, tags);
                    retValue = this.state.power.value;
                    // Some Vivitek projectors will respond with op status = \d and others will respond
                    // with P\d, so we support both styles of responses.
                    if (match[1]) {
                        retValue = match[1].toLowerCase() === 'on';
                    }
                    else if (match[2] && match[2] in this.powerValues) {
                        retValue = this.powerValues[match[2]];
                    }
                }
                catch (err) { }
                this.framework.suspend(suspendMs);
                this.busyTimeout.set(() => this.state.busy.update(false), suspendMs);
                return retValue;
            }),
        };
        this.serialNumber = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`op ser.no ?`, /op\s+ser\.no\s+=\s+(\S+)|P(\d+)$/i, tags);
                return match[1] ? match[1] : 'unknown';
            }),
            powerOffRestrictions: ['get'],
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`op input.sel ?`, /op\s+input\.sel\s+=\s+(\d+|NA)|P(\d+)$/i, tags);
                if (match[1] !== undefined && match[1].toUpperCase() !== 'NA') {
                    return match[1];
                }
                return this.state.videoInput.value;
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`op input.sel = ${code}`, /op\s+input\.sel\s+=\s+(\d+|NA)|P(\d*)$/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 1000);
                if (match[1] !== undefined && match[1].toUpperCase() !== 'NA') {
                    return match[1];
                }
                return this.state.videoInput.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`op volume ?`, /op\s+volume\s+=\s+(\d+|NA)|P(\d+)$/i, tags);
                if (match[1] === undefined || match[1] === 'NA')
                    return this.state.volume.value;
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`op volume = ${volume}`, /op volume = (\d+|NA)|P(\d*)$/i, tags);
                if (match[1] === undefined || match[1] === 'NA')
                    return this.state.volume.value;
                return parseInt(match[1], 10);
            }),
            hasControl: () => __awaiter(this, void 0, void 0, function* () {
                try {
                    const match = yield this.socket.send(`op volume ?`, /op\s+volume\s+=\s+(\d+|NA)|unknown command|P(\d+)$/i, ['hasControl.volume']);
                    if (match[1] === undefined)
                        return false;
                    return match[1] ? true : false;
                }
                catch (error) {
                    if (error instanceof TransportError && error.code === 'sendTimeout')
                        return false;
                    throw error;
                }
            }),
            powerOffRestrictions: ['get', 'set', 'hasControl'],
            range: { max: 10, min: 0, round: 1 },
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`op mute ?`, /op mute = (\d|NA)|P(\d+)$/i, tags);
                if (match[1] === undefined || match[1] === 'NA')
                    return this.state.volumeMute.value;
                return match[1] === '1';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`op mute = ${mute ? '1' : '0'}`, /op\s+mute\s+=\s+(\d|NA)|P(\d+)$/i, tags);
                if (match[1] === undefined || match[1] === 'NA')
                    return this.state.volumeMute.value;
                return match[1] === '1';
            }),
            hasControl: () => __awaiter(this, void 0, void 0, function* () {
                try {
                    const match = yield this.socket.send(`op mute ?`, /op\s+mute\s+=\s+(\d|NA)|unknown command|P(\d*)$/i, ['hasControl.volumeMute']);
                    if (match[1] === undefined)
                        return false;
                    return match[1] ? true : false;
                }
                catch (error) {
                    if (error instanceof TransportError && error.code === 'sendTimeout')
                        return false;
                    throw error;
                }
            }),
            powerOffRestrictions: ['get', 'set', 'hasControl'],
        };
        // polling
        this.polls = [
            {
                intervalMs: 3000,
                onePerInterval: true,
                controls: ['power', 'videoInput'],
            },
            {
                intervalMs: 5000,
                onePerInterval: true,
                controls: ['volume', 'volumeMute', 'displayBlank', 'displayFreeze'],
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.state.busy.update(false); // reset in case phase change clears busy timeout
            this.timeouts.clearAll();
            this.powerValues =
                config.modelNumber === Model.D7000 || config.modelNumber === Model.D7098Z
                    ? {
                        '0': false,
                        '1': false,
                        '2': true,
                        '3': false,
                        '4': true,
                        '5': true, // power up
                    }
                    : {
                        '0': false,
                        '1': true,
                        '2': true,
                        '3': false,
                        '4': true, // error
                    };
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.socket.port !== 4999)
                return 'connected';
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
VivitekProjector7000.driverType = 'socketDriver';
VivitekProjector7000.key = '-MCChooqa81xM8o0Nxsg';
VivitekProjector7000.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r'],
    },
    sendTerminator: '\r',
    idleTimeoutMs: 40000, // Sometimes the projectors don't respond to commands
};
VivitekProjector7000.socketOptions = (config) => {
    const port = config.modelNumber === Model.D7000 ? 23 : 7000;
    return [
        Object.assign(Object.assign({}, VivitekProjector7000.baseSocketOptions), { idleTimeoutMs: 0, port }),
        Object.assign(Object.assign({}, VivitekProjector7000.baseSocketOptions), { port: 4999 }),
    ];
};
